import React from 'react';
import { Link, withRouter, NavLink as RouterLink } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import opptimise_logo_big from '../../../images/opptimise_logo_big.png';

import './index.css'

import {
    Collapse,
    Navbar as NavbarMain,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import { analyseActions } from '../../../_actions'
class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            permission: "people"
        }
    }

    logout = () => {
        localStorage.clear()
        const fd1 = {
            'assessor_groups_for_team': [],
            'team_members': []
        }
        this.props.dispatch(analyseActions.saveAssessorGroups(null))
        // this history.replace('/login');
    }


    render() {
        const { navItems } = this.props;
        return (
            <div >
                <NavbarMain className="navbar-main p-0" light expand="md" style={{ backgroundColor: navItems.length == 0 ? "rgba(25, 25, 25, 0.3)" : this.state.permission == "people" ? "#000" : "rgb(60, 0, 106)" }}>
                    <NavbarBrand tag={Link} to={`/`} className="center-align-children px-2" onClick={() => {this.props.dispatch({type: "RELOAD_FALSE"})}}>
                        <div className="d-flex justify-content-center align-items-center p-2">
                            <img src={opptimise_logo_big} style={{width: 50}} />
                        </div>
                        <p className="navbar-brand-para pl-2">{this.state.permission == "people" ? "Behavioral" : "My"} Analytics</p>
                    </NavbarBrand>
                    {
                        navItems.length != 0 &&
                        <NavbarBrand tag={Link} to={`/`} className="center-align-children-version" >
                            {/* <p className="navbar-brand-para-version">by DiscoverSelf</p> */}
                        </NavbarBrand>
                    }
                    <Collapse navbar style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <Nav className="ml-auto" navbar>
                            {
                                navItems != undefined &&
                                <React.Fragment>
                                    {
                                        navItems.map((val, key) => (
                                    <NavItem key={key} className="center-align-children" style={{ paddingLeft: 10, paddingRight: 10, borderBottomWidth: 0, borderTopWidth: 0, borderLeftWidth: 0.3, borderRightWidth: 0, borderStyle: 'solid', borderColor: 'grey' }}>
                                        <RouterLink to={`${val.link}`} className="nav-link">{val.navName}</RouterLink>
                                    </NavItem>
                                    //     <NavLink tag={Link} to={`${val.link}`} activeClassName="active"><p className='nav-items-para' style={{marginBottom: 0}}>
                                    //     {val.navName}
                                    // </p></NavLink>
                                ))
                                    }
                                </React.Fragment>
                            }
                            <NavItem className="center-align-children" style={{ height: 50, paddingLeft: 10, paddingRight: 10, borderBottomWidth: 0, borderTopWidth: 0, borderLeftWidth: navItems.length == 0 ? 0 : 0.3, borderRightWidth: 0, borderStyle: 'solid', borderColor: 'grey' }}>

                                {/* <RouterLink className=" nav-link text-dark" to="/login">
                                    <span onClick={this.logout} className="green-hover"><i className="fa fa-sign-out-alt  text-green "></i> &nbsp;Logout</span>
                                </RouterLink> */}
                                <RouterLink  to={`/login`} onClick={() => this.props.dispatch({type: "RELOAD_FALSE"})}>
                                <i onClick={this.logout} className="fa fa-power-off fa-lg text-white" style={{ fontSize: '1.8rem' }}  ></i>
                                </RouterLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </NavbarMain>
            </div>
        );
    }
}

Navbar.propTypes = {
    navItems: PropTypes.array
};

const mapStateToProps = state => ({state})

export default connect(mapStateToProps)(Navbar)




// WEBPACK FOOTER //
// ./src/_components/common/Navbar/index.js